import DiscoveryCategoriesRoute from "discourse/routes/discovery-categories";

export default class DiscoverySubcategoriesRoute extends DiscoveryCategoriesRoute {}
